<template>
    <v-dialog v-model="dialog" scrollable  max-width="600">
        <v-card v-if="appointment">
            <v-card-title  :class="['pb-0 white--text', 'primary']">
                <v-icon class="mr-2" color="white" @click="hide">mdi-close</v-icon>
                <div class="title-container">
                  <div class="appointment-title">Detalle de la cita</div>
                  <small class="appointment-subtitle">{{appointment.scheduled_from === 'internal' ? 'Agendado desde sistema' : `Agendado por ${clientSingular.toLowerCase()}`}}</small>
                </div>
                <v-spacer></v-spacer>
                <v-btn x-small rounded outlined
                       :loading="loading"
                       @click="confirm"
                       :fab="isMobile"
                       dark
                       v-if="appointment.client && appointment.event_status.id < 2" >
                  <span v-if="!isMobile">Confirmar</span>
                  <v-icon v-else>mdi-check-all</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
              <v-list dense v-if="appointment.client" >

                <appointment-details-section
                    dense
                    :content="getDatetimeText(appointment)"
                    icon="mdi-calendar-clock"
                    label="Fecha y hora"
                >
                  <template v-slot:actions>

                    <v-btn rounded x-small dark :fab="isMobile" depressed color="teal" @click="$emit('click:history', appointment.client.id)">
                      <v-icon size="12" color="white" :class="!isMobile ? 'mr-1' : ''">mdi-clock</v-icon>
                      <span v-if="!isMobile">historial</span>
                    </v-btn>
                  </template>

                </appointment-details-section>

                <v-divider></v-divider>

                <appointment-details-section
                    icon="mdi-account"
                    :label="getLabel('commons.client.singular')"
                >

                  <template v-slot:content>
                    {{`${appointment.client.first_name} ${appointment.client.last_name}`}}
                    <span v-if="appointment.client.dni" class="text-caption font-weight-bold">| {{appointment.client.dni | rut}}</span>
                  </template>

                  <template v-slot:actions>

                    <v-btn rounded x-small :fab="isMobile" depressed color="primary" @click="$emit('click:edit', appointment.client)">
                      <v-icon size="12" color="white" :class="!isMobile ? 'mr-1' : ''">mdi-pencil</v-icon>
                      <span v-if="!isMobile">editar</span>
                    </v-btn>

                  </template>
                </appointment-details-section>

                <v-divider></v-divider>

                <appointment-details-section
                    :content="getPaymentText(appointment.payment)"
                    icon="mdi-cash"
                    label="Datos de Pago">
                  <template v-slot:actions>
                    <v-btn rounded x-small :fab="isMobile" depressed color="primary" @click="$emit('click:edit:payment', appointment)">
                      <v-icon size="12" color="white" :class="!isMobile ? 'mr-1' : ''">mdi-pencil</v-icon>
                      <span v-if="!isMobile">editar</span>
                    </v-btn>
                  </template>
                </appointment-details-section>

                <v-divider></v-divider>

                <template v-if="currentProviderSettings && currentProviderSettings.allow_labels_on_appointments">
                  <appointment-details-section
                      icon="mdi-label" label="Etiquetas">

                    <template v-slot:content>
                      <template v-if="!appointment.labels || appointment.labels.length === 0">
                        Sin etiquetas asociadas
                      </template>
                      <v-chip-group>
                        <v-chip small outlined :color="label.color" v-for="(label, i) in appointment.labels" :key="`label-${i}`">
                          {{label.description}}
                        </v-chip>
                      </v-chip-group>
                    </template>

                    <template v-slot:actions>
                      <v-btn rounded x-small :fab="isMobile" depressed color="primary" @click="showLabelsDetails = true">
                        <v-icon size="12" color="white" :class="!isMobile ? 'mr-1' : ''">mdi-pencil</v-icon>
                        <span v-if="!isMobile">editar</span>
                      </v-btn>
                    </template>

                  </appointment-details-section>

                  <v-divider class="my-2"></v-divider>
                </template>

                <template>
                  <appointment-details-section icon="attach_file" label="Adjuntos">
                    <template v-slot:content>
                      <template v-if="!documents || documents.length === 0">
                        Sin adjuntos
                      </template>

                      <v-chip-group>
                        <v-chip :title="document.name" @click="openDoc(document.path)" small outlined color="primary" v-for="(document, i) in documents" :key="`doc-${i}`">
                          {{document.name | truncate(20)}}
                        </v-chip>
                      </v-chip-group>

                    </template>

                    <template v-slot:actions>

                      <v-btn rounded x-small :fab="isMobile" depressed color="primary" @click="showDocsManager()">
                        <v-icon size="12" color="white" :class="!isMobile ? 'mr-1' : ''">mdi-pencil</v-icon>
                        <span v-if="!isMobile">editar</span>
                      </v-btn>

                      <docs-manager
                          v-if="appointment"
                          :event="appointment"
                          ref="docsManager"
                          :docs="documents"
                          @delete="onDocumentDeleted"
                          @upload="onDocumentUploaded"
                      />
                    </template>
                  </appointment-details-section>

                  <v-divider class="my-2"></v-divider>
                </template>


                <appointment-details-section
                    icon="mdi-cards-variant"
                    label="Estado de la cita"
                >
                  <template v-slot:content>
                    <event-status-chip :event-status="appointment.event_status"/>
                    <v-chip class="ml-1 pa-2" small outlined v-if="appointment && appointment.confirmed_by">
                      <v-icon size="20" class="mr-2">mdi-account</v-icon>
                      confirmado por: {{appointment.confirmed_by.first_name}}
                    </v-chip>
                  </template>
                </appointment-details-section>

                <v-divider></v-divider>

                <appointment-details-section
                    dense
                    hide-actions
                    icon="mdi-account-box"
                    label="Contacto"
                >
                  <template v-slot:content>

                    <v-chip-group>

                      <v-chip small color="primary" outlined link>
                        <v-icon size="16" class="mr-1">mdi-email</v-icon>
                        <template v-if="appointment.client.email">
                          <a :href="`mailto:${appointment.client.email}`">{{ appointment.client.email }}</a>
                        </template>
                        <template v-else>n/d</template>
                      </v-chip>

                      <v-chip small color="primary" outlined link>
                        <v-icon size="16" class="mr-1">mdi-cellphone</v-icon>
                        <template v-if="appointment.client.phone1">
                          <a :href="`tel:+56${appointment.client.phone1}`">{{ appointment.client.phone1 }}</a>
                        </template>
                        <template v-else>n/d</template>
                      </v-chip>

                      <v-chip small color="primary" outlined link>
                        <v-icon size="16" class="mr-1">mdi-phone</v-icon>
                        <template v-if="appointment.client.phone2">
                          <a :href="`tel:+56${appointment.client.phone2}`">{{ appointment.client.phone2 }}</a>
                        </template>
                        <template v-else>n/d</template>
                      </v-chip>

                    </v-chip-group>

                  </template>
                </appointment-details-section>

                <v-divider></v-divider>

              </v-list>

              <template v-if="appointment.cancelled_events && appointment.cancelled_events.length > 0">


                <div class="subtitle-2 mb-2 mt-3">{{`${clientPlural} que han cancelado esta cita`}}:</div>

                <v-simple-table class="secondary-card" dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th scope="col" class="text-left">{{clientSingular}}</th>
                        <th scope="col" class="text-left">Motivo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                          v-for="(item) in appointment.cancelled_events"
                          :key="item.id">
                        <td style="width: 80px" class="text-left text-truncate">{{item.client.first_name}} {{item.client.last_name}}</td>
                        <td class="text-truncate">{{getEventCancelReason(item.reason)}}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

              </template>
            </v-card-text>
        </v-card>
      <labels-details-dialog
          v-if="appointment"
          :show="showLabelsDetails"
          :event-id="appointment.id"
          :history="appointment.labels_history"
          :labels="appointment.labels"
          @close="showLabelsDetails = false"
      />
    </v-dialog>
</template>

<script>

    import {getLabel} from '@/utils/Institution'
    import {getEventCancelReason, getPaymentType} from '@/utils/Strings'
    import {getStatusColor} from "@/utils/ScheduleEvent";

    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations} from 'vuex'
    import AppointmentDetailsSection from "@/components/appointments/details/AppointmentDetailsSection";
    import EventStatusChip from "@/components/appointments/EventStatusChip";
    import ProviderSettingsMixin from "@/mixins/ProviderSettingsMixin";
    import LabelsDetailsDialog from "@/components/appointments/details/LabelsDetailsDialog";
    import DocsManager from "@/components/appointments/attention/DocsManager.vue";
    import AppointmentDocumentsMixin from "@/mixins/AppointmentDocumentsMixin";

    export default{
      components: {DocsManager, LabelsDetailsDialog, EventStatusChip, AppointmentDetailsSection},
      props: ['appointment'],
      mixins: [ProviderSettingsMixin, AppointmentDocumentsMixin],
        data(){
            return {
              dialog: false,
              loading: false,
              showLabelsDetails: false,
            }
        },

        methods: {
                ...mapMutations(['showSnackBar']),
            getLabel,
            getEventCancelReason,
            getPaymentType,
            getStatusColor,
            initDocsManager() {
              const vm = this
              console.debug('initializing docs')
              if(!this.appointment) return
              vm.connectDocumentsSocket(this.appointment)
            },
            showDocsManager(){
              this.$refs.docsManager.show()
            },
            getPaymentText(payment){
              const vm = this
              const type = vm.getPaymentType(payment.type)
              const description = payment.type === 'medical_voucher'
                  ? `( Folio: ${payment.voucher_number || 'sin folio'} )` : ''

              return `${type} ${description}`
            },
            getDatetimeText(appointment){
              return this.$moment(`${appointment.date} ${appointment.time}`)
                  .format('DD/MM/YYYY | HH:mm') + ' hrs.'
            },
            syncLabels(labels){
              const vm = this
              console.log('labels sync: ', labels)
            },
            async confirm(){

                var vm = this

                vm.loading = true
                const response = await ApiUtils.makePost(`appointments/${vm.appointment.id}/confirm`)
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando confirmar la cita')
                    return
                }

                const json = await response.json()
                vm.$emit('update:status', json.result.event)

            },
            show(){
                var vm = this
                vm.dialog = true
            },
            hide(){
                var vm = this
                vm.dialog = false
            }
        },
        watch: {
            appointment(val){
              const vm = this
              if(val){
                vm.initDocsManager()
              }
            }
        }

    }
</script>

<style scoped>
  .title-container{
    height: 55px;
    flex-direction: column;
  }

  .appointment-title{
    font-size: 1.1em;
    flex: 1;
    height: 20px;
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
  }

  .appointment-subtitle{
    font-size: .6em;
    flex: 1;
  }


</style>
